angular.module('zc.commonApi')
  .factory('CampaignSegmentStats', CampaignSegmentStatsService);

CampaignSegmentStatsService.$inject = ['$q', 'FacadeV2'];
function CampaignSegmentStatsService($q, FacadeV2) {
  return {
    find,
    aggregate
  };

  function find(paths = {}, query = {}, options = {}) {
    return $q((resolve, reject) => {
      if(!paths.apikey) {
        const errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if(!paths.dimension) {
        const errorMsg = 'No dimension';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      return FacadeV2.request(`/apikeys/${paths.apikey}/campaign_segment_stats/${paths.dimension}/find`, {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(res => {
        if(res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(transformData(res.data));
        }
      });
    });
  }

  function aggregate(paths = {}, query = {}) {
    return $q((resolve, reject) => {
      if(!paths.apikey) {
        const errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if(!paths.dimension) {
        const errorMsg = 'No dimension';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      return FacadeV2.request(`/apikeys/${paths.apikey}/campaign_segment_stats/${paths.dimension}/aggregate`, {
        params: {
          match: query.match,
          pipeline: query.pipeline
        },
        cache: false
      }).then(res => {
        if(res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(res.data);
        }
      });
    });
  }

  function transformData(campaignSegmentStats) {
    _.each(campaignSegmentStats, stats => {
      if(stats.start_at) {
        stats.start_at = new Date(stats.start_at).valueOf();
      }
      if(stats.end_at) {
        stats.end_at = new Date(stats.end_at).valueOf();
      }
    });
    return _.sortBy(campaignSegmentStats, stats => stats.start_at);
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_segment_stats.service.js